<template>
    <div class='is-flex is-horizontal-center'>
        <figure class='image'><img src="../../assets/images/financial-norms-ratios-logo.png" alt="Financial Norms and Ratios"></figure>
    </div>
</template>

<script>
export default {
    name: 'LoginLogo',
    data() {
        return {
            logo: 'financial-norms-ratios-logo.png'
      }

    },
    computed: {
    imageSrc: function () {
        return './../assets/images/financial-norms-ratios-logo.png'
    }
}
}
</script>

<style scoped>
.is-horizontal-center {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/features/LoginLogo.vue